import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Company', href: '#company' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 flex items-center justify-between h-16">
        <span
          className={`font-bold tracking-widest text-sm uppercase cursor-pointer transition-colors duration-300 ${
            scrolled ? 'text-[#1A2332]' : 'text-white'
          }`}
          onClick={() => handleNav('#company')}
        >
          BLANO DOO
        </span>

        {/* Desktop nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <button
                onClick={() => handleNav(link.href)}
                className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-[#555]  hover:text-[#1A2332]' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden text-xl cursor-pointer transition-colors duration-300 ${
            scrolled ? 'text-[#1A2332]' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link.href)}
              className="text-sm font-medium text-[#1A2332] text-left cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
